import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const Redirect = ({ path }) => {
  const navigate = useNavigate();
  const params = useParams();

  useEffect(() => {
    // Replace dynamic parameters in the path
    let finalPath = path;
    
    // Replace :id with actual id parameter
    if (params.id) {
      finalPath = finalPath.replace(':id', params.id);
    }

    if (params.supplier_id) {
      finalPath = finalPath.replace(':supplier_id', params.supplier_id);
    }

    navigate(finalPath);
    location.reload();
  }, []);

  return null;
};

export default Redirect;